import { useClient } from "@app/portal-sdk";
import { EmptyState, Stack } from "@app/ui-kit";
import { ClientSettingsSection } from "./ClientSettingsSection";

/**
 * SET-1: Regional and fiscal, the REF-7 controls under the client's own
 * settings section. Moved, not rebuilt: the same component the admin console
 * renders, reading and writing the client's own row, with the ADM-5 impact
 * preview and confirmation. canManage only.
 */
export const RegionalFiscal = () => {
  const { client, canManage, refreshClient } = useClient();
  if (!canManage) {
    return <EmptyState eyebrow="Regional and fiscal" title="A client administrator changes these" description="The fiscal year, currency, locale and time zone are set by an administrator of this client." />;
  }
  return (
    <Stack spacing={3}>
      <ClientSettingsSection client={client} base={`/clients/${client.id}/settings`} eyebrow="Settings" title="Regional and fiscal" onSaved={() => { void refreshClient(); }} />
    </Stack>
  );
};
